const STORAGE_KEYS = {
  TRANSLATIONS: "translations",
  TRANSLATIONS_VERSION: "translations_version",
  TRANSLATIONS_SELECTED_LOCALE: "translations_locale",
};

export const storeTranslations = async ({ locales, version }) => {
  try {
    localStorage.setItem(STORAGE_KEYS.TRANSLATIONS, JSON.stringify(locales));
    localStorage.setItem(STORAGE_KEYS.TRANSLATIONS_VERSION, version);
  } catch (e) {
    console.error("error saving Translations", e);
  }
};

export const storeTranslationsSelectedLocale = async (locale) => {
  try {
    localStorage.setItem(STORAGE_KEYS.TRANSLATIONS_SELECTED_LOCALE, locale);
  } catch (e) {
    console.error("error saving storeTranslationsSelectedLocale", e);
  }
};

export const loadTranslations = async () => {
  try {
    const jsonValue = localStorage.getItem(STORAGE_KEYS.TRANSLATIONS);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (e) {
    console.error("error reading Translations", e);
    return null;
  }
};

export const getCurrentStoredTranslationsVersion = async () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.TRANSLATIONS_VERSION);
  } catch (e) {
    console.error("error reading getCurrentStoredTranslationsVersion", e);
    return null;
  }
};

export const getSelectedLocale = async () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.TRANSLATIONS_SELECTED_LOCALE);
  } catch (e) {
    console.error("error reading getSelectedLocale", e);
    return null;
  }
};
